import { FeatureFlag, useFeatureFlag } from '@src/config/featureFlags';
import { isPreviewRoute } from '@src/constants/navigation';
import { useMemo } from 'react';

/**
 * 現在のパスに対してプレビューを表示すべきかどうかを判定するフック。
 * フィーチャーフラグも考慮して判定します。
 */
export const usePreviewVisibility = (path: string): boolean => {
  const isRirekishoEnabled = useFeatureFlag(FeatureFlag.USE_RIREKISHO);
  const isResumeEnabled = useFeatureFlag(FeatureFlag.USE_RESUME);

  return useMemo(() => {
    // 基本的なプレビュー表示判定
    if (!isPreviewRoute(path)) {
      return false;
    }

    // 履歴書ページかつ履歴書フラグがオフの場合は非表示
    if (path.startsWith('/rirekisho') && !isRirekishoEnabled) {
      return false;
    }

    // 経歴書ページかつ経歴書フラグがオフの場合は非表示
    // 経歴書ページは /rirekisho 以外のほとんどのページなので、除外条件で判定
    const isResumeRelatedPath =
      !path.startsWith('/rirekisho') &&
      path !== '/' &&
      !path.startsWith('/login') &&
      !path.startsWith('/register') &&
      !path.startsWith('/profile') &&
      !path.startsWith('/faq') &&
      !path.startsWith('/data') &&
      !path.startsWith('/saved-data');

    if (isResumeRelatedPath && !isResumeEnabled) {
      return false;
    }

    return true;
  }, [path, isRirekishoEnabled, isResumeEnabled]);
};
